import { useHistory, useLocation } from '@shared/core';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

/**
 * Generic utilty hook that will handles all search params updates for the accommodations console
 */
export const useUpdateAccommodationsConsoleSearchParams = () => {
  const history = useHistory();
  const location = useLocation();
  const applyAccommodationConsoleSearchParamsToUrl = useEventCallback(
    (args: { searchParams: Record<string, string | null>; actionType: 'replace' | 'push'; locationHash?: string }) => {
      const { searchParams: searchParamOverrides, actionType, locationHash } = args;
      const params = new URLSearchParams(location.search);

      Object.entries(searchParamOverrides).forEach(([key, value]) => {
        if (value === null || value === '') {
          params.delete(key);
        } else {
          params.set(key, value);
        }
      });

      history[actionType]?.({
        pathname: location.pathname,
        hash: locationHash,
        search: params.toString(),
      });
    },
  );

  return {
    applyAccommodationConsoleSearchParamsToUrl,
  };
};
